import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-4dce8826"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-input-icon-left" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_Column = _resolveComponent("Column")!
  const _component_ProductName = _resolveComponent("ProductName")!
  const _component_ProductMultiSelect = _resolveComponent("ProductMultiSelect")!
  const _component_CategoryName = _resolveComponent("CategoryName")!
  const _component_CategoryMultiSelect = _resolveComponent("CategoryMultiSelect")!
  const _component_NumberFormatter = _resolveComponent("NumberFormatter")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_Row = _resolveComponent("Row")!
  const _component_ColumnGroup = _resolveComponent("ColumnGroup")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_SequencesSelect = _resolveComponent("SequencesSelect")!
  const _component_TicketGet = _resolveComponent("TicketGet")!
  const _component_RapportFilter = _resolveComponent("RapportFilter")!

  return (_openBlock(), _createBlock(_component_RapportFilter, {
    startAt: _ctx.input.startAt,
    "onUpdate:startAt": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.input.startAt) = $event)),
    endAt: _ctx.input.endAt,
    "onUpdate:endAt": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.input.endAt) = $event)),
    period: _ctx.input.period,
    "onUpdate:period": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.input.period) = $event)),
    loading: _ctx.loading,
    onValidate: _cache[8] || (_cache[8] = ($event: any) => (_ctx.initData())),
    label: "none"
  }, {
    table: _withCtx(() => [
      _createVNode(_component_DataTable, {
        dataKey: "id",
        "auto-layout": "",
        rowHover: false,
        value: (_ctx.movements as any[]),
        rows: 20,
        onFilter: _ctx.onFilter,
        "rows-per-page-options": _ctx.rowsPerPageOptions,
        filters: _ctx.filters,
        "onUpdate:filters": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filters) = $event)),
        filterDisplay: "menu",
        showGridlines: "",
        paginator: true,
        responsiveLayout: "scroll",
        globalFilterFields: ['product', 'categoryName'],
        class: "p-datatable-sm",
        "sort-field": "createdAt",
        "sort-order": -1,
        style: {"height":"calc(100vh - 194px)"},
        scrollable: "",
        "scroll-height": "flex"
      }, {
        header: _withCtx(() => [
          _createVNode(_component_Button, {
            class: "p-button-sm p-button-outlined p-button-rounded",
            icon: "pi pi-refresh",
            label: _ctx.$t('clear'),
            onClick: _ctx.refresh
          }, null, 8, ["label", "onClick"]),
          _createVNode(_component_Button, {
            disabled: !_ctx.movements.length,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.print())),
            label: _ctx.$t('pos.print'),
            icon: "pi pi-print"
          }, null, 8, ["disabled", "label"]),
          _createElementVNode("span", _hoisted_1, [
            _hoisted_2,
            _createVNode(_component_InputText, {
              modelValue: _ctx.filters.global.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filters.global.value) = $event)),
              placeholder: _ctx.$t('search'),
              style: {"width":"100%"}
            }, null, 8, ["modelValue", "placeholder"])
          ])
        ]),
        default: _withCtx(() => [
          _createVNode(_component_Column, {
            "show-add-button": false,
            showFilterOperator: false,
            field: "createdAt",
            header: _ctx.$t('date'),
            dataType: "date",
            sortable: true,
            "sort-field": "createdAt"
          }, {
            body: _withCtx(({ data }) => [
              _createTextVNode(_toDisplayString(_ctx.$d(data.createdAt, "long")), 1)
            ]),
            filter: _withCtx(({ filterModel }) => [
              _createVNode(_component_Calendar, {
                modelValue: filterModel.value,
                "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                dateFormat: _ctx.$t('format.range'),
                placeholder: _ctx.$t('format.range')
              }, null, 8, ["modelValue", "onUpdate:modelValue", "dateFormat", "placeholder"])
            ]),
            filterclear: _withCtx(({ filterCallback }) => [
              _createVNode(_component_Button, {
                type: "button",
                onClick: ($event: any) => (filterCallback()),
                class: "p-button-warning p-button-sm",
                label: _ctx.$t('prime.clear')
              }, null, 8, ["onClick", "label"])
            ]),
            filterapply: _withCtx(({ filterCallback }) => [
              _createVNode(_component_Button, {
                label: _ctx.$t('search'),
                type: "button",
                icon: "pi pi-search",
                class: "p-button-sm",
                onClick: ($event: any) => (filterCallback())
              }, null, 8, ["label", "onClick"])
            ]),
            _: 1
          }, 8, ["header"]),
          _createVNode(_component_Column, {
            field: "product",
            "show-filter-match-modes": false,
            "show-add-button": false,
            showFilterOperator: false,
            sortable: true,
            "filter-field": "productId",
            "sort-field": "product",
            header: _ctx.$t('product.product')
          }, {
            body: _withCtx(({ data }) => [
              _createVNode(_component_ProductName, {
                product: { name: data.product }
              }, {
                default: _withCtx(({ name }) => [
                  _createTextVNode(_toDisplayString(name), 1)
                ]),
                _: 2
              }, 1032, ["product"])
            ]),
            filter: _withCtx(({ filterModel }) => [
              _createVNode(_component_ProductMultiSelect, {
                modelValue: filterModel.value,
                "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                items: _ctx.resume.products,
                style: {"max-width":"220px"}
              }, null, 8, ["modelValue", "onUpdate:modelValue", "items"])
            ]),
            filterclear: _withCtx(({ filterCallback }) => [
              _createVNode(_component_Button, {
                type: "button",
                onClick: ($event: any) => (filterCallback()),
                class: "p-button-warning p-button-sm",
                label: _ctx.$t('prime.clear')
              }, null, 8, ["onClick", "label"])
            ]),
            filterapply: _withCtx(({ filterCallback }) => [
              _createVNode(_component_Button, {
                label: _ctx.$t('search'),
                type: "button",
                icon: "pi pi-database",
                class: "p-button-sm p-ml-2",
                onClick: ($event: any) => (filterCallback())
              }, null, 8, ["label", "onClick"])
            ]),
            _: 1
          }, 8, ["header"]),
          _createVNode(_component_Column, {
            showFilterMatchModes: false,
            "show-add-button": false,
            showFilterOperator: false,
            field: "category",
            sortable: true,
            "filter-field": "categoryId",
            "sort-field": "category",
            header: _ctx.$t('product.category')
          }, {
            body: _withCtx(({ data }) => [
              _createVNode(_component_CategoryName, {
                category: { label: data.category }
              }, {
                default: _withCtx(({ name }) => [
                  _createTextVNode(_toDisplayString(name), 1)
                ]),
                _: 2
              }, 1032, ["category"])
            ]),
            filter: _withCtx(({ filterModel }) => [
              _createVNode(_component_CategoryMultiSelect, {
                modelValue: filterModel.value,
                "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                items: _ctx.resume.categories,
                style: {"max-width":"220px"}
              }, null, 8, ["modelValue", "onUpdate:modelValue", "items"])
            ]),
            filterclear: _withCtx(({ filterCallback }) => [
              _createVNode(_component_Button, {
                type: "button",
                onClick: ($event: any) => (filterCallback()),
                class: "p-button-warning p-button-sm",
                label: _ctx.$t('prime.clear')
              }, null, 8, ["onClick", "label"])
            ]),
            filterapply: _withCtx(({ filterCallback }) => [
              _createVNode(_component_Button, {
                label: _ctx.$t('search'),
                type: "button",
                icon: "pi pi-database",
                class: "p-button-sm p-ml-2",
                onClick: ($event: any) => (filterCallback())
              }, null, 8, ["label", "onClick"])
            ]),
            _: 1
          }, 8, ["header"]),
          _createVNode(_component_Column, {
            field: "ticket",
            "show-filter-match-modes": false,
            "show-add-button": false,
            showFilterOperator: false,
            sortable: true,
            "filter-field": "ticket",
            "sort-field": "ticket",
            header: _ctx.$t('ticket.number_'),
            "body-class": "flex p-justify-between"
          }, {
            body: _withCtx(({ data }) => [
              _createVNode(_component_Button, {
                onClick: ($event: any) => (_ctx.openDetails(data.ticket)),
                icon: "pi pi-eye",
                "icon-pos": "right",
                label: `${_ctx.formatNumber(data.ticket)}`,
                class: "p-button-text p-button-secondary"
              }, null, 8, ["onClick", "label"])
            ]),
            filter: _withCtx(({ filterModel }) => [
              _createVNode(_component_CategoryMultiSelect, {
                placeholder: _ctx.$t('rapport.byTickets'),
                modelValue: filterModel.value,
                "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                items: _ctx.resume.tickets,
                style: {"max-width":"220px"}
              }, null, 8, ["placeholder", "modelValue", "onUpdate:modelValue", "items"])
            ]),
            filterclear: _withCtx(({ filterCallback }) => [
              _createVNode(_component_Button, {
                type: "button",
                onClick: ($event: any) => (filterCallback()),
                class: "p-button-warning p-button-sm",
                label: _ctx.$t('prime.clear')
              }, null, 8, ["onClick", "label"])
            ]),
            filterapply: _withCtx(({ filterCallback }) => [
              _createVNode(_component_Button, {
                label: _ctx.$t('search'),
                type: "button",
                icon: "pi pi-database",
                class: "p-button-sm p-ml-2",
                onClick: ($event: any) => (filterCallback())
              }, null, 8, ["label", "onClick"])
            ]),
            _: 1
          }, 8, ["header"]),
          _createVNode(_component_Column, {
            "sort-field": "quantity",
            sortable: true,
            field: "quantity",
            header: _ctx.$t('product.quantity'),
            "show-add-button": false,
            showFilterOperator: false,
            "filter-field": "quantity",
            dataType: "numeric"
          }, {
            body: _withCtx(({ data }) => [
              _createVNode(_component_NumberFormatter, {
                value: data.quantity
              }, null, 8, ["value"])
            ]),
            filter: _withCtx(({ filterModel }) => [
              _createVNode(_component_InputNumber, {
                modelValue: filterModel.value,
                "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                "max-fraction-digits": 20,
                min: 0,
                mode: "decimal"
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ]),
            filterclear: _withCtx(({ filterCallback }) => [
              _createVNode(_component_Button, {
                type: "button",
                onClick: ($event: any) => (filterCallback()),
                class: "p-button-warning p-button-sm",
                label: _ctx.$t('prime.clear')
              }, null, 8, ["onClick", "label"])
            ]),
            filterapply: _withCtx(({ filterCallback }) => [
              _createVNode(_component_Button, {
                label: _ctx.$t('search'),
                type: "button",
                icon: "pi pi-search",
                class: "p-button-sm",
                onClick: ($event: any) => (filterCallback())
              }, null, 8, ["label", "onClick"])
            ]),
            _: 1
          }, 8, ["header"]),
          _createVNode(_component_Column, {
            "sort-field": "amount",
            sortable: true,
            field: "amount",
            header: _ctx.$t('pos.amount'),
            "show-add-button": false,
            showFilterOperator: false,
            "filter-field": "amount",
            dataType: "numeric"
          }, {
            body: _withCtx(({ data }) => [
              _createVNode(_component_NumberFormatter, {
                value: data.amount
              }, null, 8, ["value"]),
              _createTextVNode(" " + _toDisplayString(_ctx.currency), 1)
            ]),
            filter: _withCtx(({ filterModel }) => [
              _createVNode(_component_InputNumber, {
                modelValue: filterModel.value,
                "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                "max-fraction-digits": 20,
                min: 0,
                mode: "decimal"
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ]),
            filterclear: _withCtx(({ filterCallback }) => [
              _createVNode(_component_Button, {
                type: "button",
                onClick: ($event: any) => (filterCallback()),
                class: "p-button-warning p-button-sm",
                label: _ctx.$t('prime.clear')
              }, null, 8, ["onClick", "label"])
            ]),
            filterapply: _withCtx(({ filterCallback }) => [
              _createVNode(_component_Button, {
                label: _ctx.$t('search'),
                type: "button",
                icon: "pi pi-search",
                class: "p-button-sm",
                onClick: ($event: any) => (filterCallback())
              }, null, 8, ["label", "onClick"])
            ]),
            _: 1
          }, 8, ["header"]),
          _createVNode(_component_ColumnGroup, { type: "footer" }, {
            default: _withCtx(() => [
              _createVNode(_component_Row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_Column, {
                    footer: _ctx.$t('payment.total'),
                    colspan: 4
                  }, null, 8, ["footer"]),
                  _createVNode(_component_Column, {
                    footer: `${_ctx.formatNumber(_ctx.filteredTotals.quantity)}`
                  }, null, 8, ["footer"]),
                  _createVNode(_component_Column, {
                    footer: `${_ctx.formatNumber(
                _ctx.filteredTotals.total
              )} ${_ctx.currencySymbol}`
                  }, null, 8, ["footer"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["value", "onFilter", "rows-per-page-options", "filters"])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_SequencesSelect, {
        modelValue: _ctx.input.sequences,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.input.sequences) = $event))
      }, null, 8, ["modelValue"]),
      (_ctx.details.show)
        ? (_openBlock(), _createBlock(_component_TicketGet, {
            key: 0,
            number: _ctx.details.number,
            visible: _ctx.details.show,
            "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.details.show) = $event))
          }, null, 8, ["number", "visible"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["startAt", "endAt", "period", "loading"]))
}